import { partfinitiClient } from 'core/services';
import {
  IAddJobPartNotesPayload,
  IRemoveJobPartNotePayload,
  IUpdateJobPartNotePayload,
} from 'jobs/types';

export const addJobPartNotes = async (data: IAddJobPartNotesPayload) =>
  await partfinitiClient.postForm('/bom/component/add-note-to-components', data);

export const updateJobPartNote = async (data: IUpdateJobPartNotePayload) =>
  await partfinitiClient.postForm('/bom/component-note-edit/save', data);

export const removeJobPartNote = async (data: IRemoveJobPartNotePayload) =>
  await partfinitiClient.postForm('/bom/component-note-edit/remove', data);
